import React from 'react'
import Translate from '../general/translate'
import FamewallEmbed from 'react-famewall'
import LazyImage from '../general/lazyImage'
import LazyLoadedFamewall from '../general/famewall'

const Testimonials = () => {

  return(
    <div className={"py-20 bg-[#643ADA]"} id="testimonials">
      <div className="xl:container mx-auto grid grid-cols-12 grid-flow-col pb-5">
        <div className="col-span-10 col-start-2 lg:container text-center lg:text-left flex flex-col items-center">            
            <h2 className="text-center leading-tight text-3xl lg:text-5xl text-[#F3F3F1] font-bold mb-20">
              <Translate id="testimonials.heading" foldername="home" filename="home-testimonials" />
            </h2>
            <LazyImage className={"mb-5"} src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=386347&theme=light&period=daily" alt={<Translate id="testimonials.image.alt" filename="home-testimonials" />} style={{ width: '250px', height: '54px' }} />
            <LazyLoadedFamewall wallUrl="podsqueeze" carouselMode={false}/>            
        </div>
      </div>
    </div>
  )
}

export default Testimonials